import * as React from "react";
import { useRecordContext } from "react-admin";
import { StatusChip } from "./ui";

// Pastille de statut colorée (libellé FR depuis l'enum).
export const EnumChip = ({ source, enumObj, value, size = "small" }) => {
  const record = useRecordContext();
  const id = value != null ? value : record?.[source];
  return <StatusChip value={id} enumObj={enumObj} size={size} />;
};

export default EnumChip;
